import React, { useMemo } from 'react';
import { FormInput, FormInputLabel, FormItemContainer, Row, } from '../StyledComponents';
import Grid from "@material-ui/core/Grid";

const Input = ({
    name,
    rules,
    placeholder,
    label,
    style,
    disabled,
    onChangeDefault,
    onChangeCustom,
    onPress,
    onBlur,
    required = true,
    requiredColor = '#0061C6',
    width = 'auto',
    maxLength,
    showMaxLengthLabel = true,
    background,
    cursor,
    icon,
    value,
    error = null,
    onChange = () => {},
    ...props
}) => {
  
  const renderError = useMemo(() => {
    const errorMessage = error?.message || error
    return errorMessage ? (
        <p style={{color: errorMessage ? '#F5365C' : '#000000'}}>{errorMessage}</p>
    ) : null;
  }, [error]);
    
    return (
        <FormItemContainer width={width}>
            {(!!placeholder || !!label) && (
                <FormInputLabel>
                    <label>
                        {label ?? placeholder}{' '}
                        {required && (<strong style={{color: requiredColor}}>*</strong>)}
                    </label>
                </FormInputLabel>
            )}
            <FormInput
                {...props}
                maxLength={maxLength}
                background={background}
                cursor={cursor}
                disabled={disabled}
                onBlur={(event) => onChange(event.target.value.trimEnd())}
                value={value}
                placeholder={placeholder}
                onChange={(event) => onChange(event.target.value)}
            />
            {!!icon &&
            <div style={{position: 'relative'}}>
                <div style={{
                    position: 'absolute',
                    textAlign: 'center',
                    left: '88%',
                    bottom: '6px',
                }}>{icon()}</div>
            </div>
            }
    
            {!!showMaxLengthLabel && maxLength ? (
                <Row align="space-between">
                    {
                       !! error && (<Grid item md={12}><>{renderError}</></Grid> )
                    }
                   
                    <FormInputLabel>{`${
                        value?.toString()?.length ?? 0
                    }/${maxLength}`}</FormInputLabel>
                </Row>
            ) : (
               <>{renderError}</>
            )}
        </FormItemContainer>
    );
};

export default Input;
